import React from 'react';

const FaqStructuredData = ({ blogFaqData }) => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": blogFaqData.map((item) => ({
      "@type": "Question",
      "name": item.blog_question.replace(/(<([^>]+)>)/gi, ""),
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.blog_answer.replace(/(<([^>]+)>)/gi, "")
      }
    }))
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
    />
  );
};

export default FaqStructuredData;
